module.exports = __webpack_public_path__ + "static/media/fly0150.3ba60044.webp";